





































import {
  Component,
  Prop,
  Vue,
  Provide,
  Watch,
  Mixins,
} from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import { getAccountInfo } from '@/apis/bot.api';
import { Bot } from '@/dtos/bot';
import { mounted } from '@/services/VueTimmer';
import { pick,mapKeys } from 'lodash';
import YAML from 'yaml';
import BotUtilMixins from '../../mixins/botUtilMixins';

@Component
export default class BotInfo extends Mixins(BotUtilMixins) {
  @Prop({ default: null })
  bot!: Bot;

  @Prop({ default: false })
  compact!: boolean;

  get botInfo(): Partial<Bot> {
    return <any>pick(this.bot, 'botType', 'pair', 'exchange');
  }

  get accountInfo(): Partial<Bot> {
    return <any>pick(this.rawAccountInfo, 'account_id', 'email', 'nick_name');
  }

  @Provide()
  loading = true;

  @Provide()
  rawAccountInfo: { account_id; email; nick_name; create_at } = null;

  @mounted
  getBotInfo() {
    let id = this.bot.id;
    this.loading = true;
    return getAccountInfo(this.bot)
      .then(e => this.bot.id == id && (this.rawAccountInfo = e))
      .finally(() => (this.loading = false));
  }

  @Watch('bot.id')
  onChangeBotId(bot) {
    this.getBotInfo();
  }

  snakeCaseToName(text: string) {
    return text
      .replace(/\_/g, '_')
      .replace(/^([a-z])/g, (e, f) => f.toUpperCase())
      .replace(/ ([a-z])/g, (e, f) => '_' + f.toUpperCase());
  }
  
  get configKey(){
    let botType = this.bot.type
    return this
      .snakeCaseToName(this.bot.type).toLowerCase() + "_config"
  }


  get config(){
    return this.bot.config[this.configKey] || null
  }
}
